import { combineReducers } from '@reduxjs/toolkit';
import { referralMonthlyPayoutReducer } from 'features/revenue/referral/referralMonthlyPayoutSlice';
import { referralDetailReducer } from 'features/revenue/referral/referralDetailSlice';
import { referralRevenueReducer } from 'features/revenue/referral/referralRevenueSlice';

export const referralReducer = combineReducers({
  revenue: referralRevenueReducer,
  monthly: referralMonthlyPayoutReducer,
  detail: referralDetailReducer,
});
